import { chromelessLayout } from '@atlassian/jira-chromeless-layout/src/index.tsx';
import { createChromelessEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { ThemedLazySkeleton } from '@atlassian/jira-project-theme-components/src/ui/ThemedLazySkeleton.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getProjectViewResources } from '@atlassian/jira-router-resources-business-common/src/index.tsx';
import { jiraBusinessListEmbedRoute } from '@atlassian/jira-router-routes-business-list-routes/src/jiraBusinessListEmbedRoute.tsx';
import { listEmbedEntryPoint } from '@atlassian/jira-spa-apps-business-list-embed/entrypoint.tsx';
import { NIN_NEW_ISSUE_NAVIGATOR } from '@atlassian/jira-capabilities/src/constants.tsx';
import { getRouteReporting } from '@atlassian/jira-router-routes-issue-navigator-entries/src/common/getRouteReporting.tsx';
import { EmbedIssueNavigatorSkeleton } from '@atlassian/jira-skeletons/src/ui/issue-navigator/components/embed-app.tsx';
import { issueNavigatorEmbedPageEntryPoint } from '@atlassian/jira-router-routes-issue-navigator-entries/src/ui/index.tsx';
import { getCommonProjectResources } from '@atlassian/jira-router-routes-issue-navigator-entries/src/common/getCommonProjectResources.tsx';

const listEmbedPageEntryPoint = createChromelessEntryPoint({
	main: listEmbedEntryPoint,
});

export const jiraBusinessListEmbedRouteEntry = createEntry(jiraBusinessListEmbedRoute, () => ({
	group: 'classic-business',
	ufoName: fg('jira_list_nin_merge') ? 'jwm-list-nin-embed' : 'jwm.list-embed-view',

	meta: fg('jira_list_nin_merge')
		? {
				capability: NIN_NEW_ISSUE_NAVIGATOR,
				reporting: getRouteReporting(),
			}
		: undefined,

	layout: chromelessLayout,
	skeleton: fg('jira_list_nin_merge') ? EmbedIssueNavigatorSkeleton : ThemedLazySkeleton,

	entryPoint: () => {
		if (fg('jira_list_nin_merge')) {
			return issueNavigatorEmbedPageEntryPoint;
		}
		return listEmbedPageEntryPoint;
	},

	resources: fg('jira_list_nin_merge') ? getCommonProjectResources() : getProjectViewResources(),

	bifrost: {
		bifrostGroup: 'shell-only',

		bundling: {
			packageName:
				'@atlassian/jira-router-routes-business-list-entries/src/jiraBusinessListEmbedRouteEntry.tsx',
			whichExportToUse: 'jiraBusinessListEmbedRouteEntry',
		},

		enabled: true,
	},
}));
